import React, { useEffect, useMemo, useRef, useState } from "react";

function CustomDropdownWithLable({
  items = [],
  selectedItem = null,
  label = "",
  placeholder = "Select",
  labelKey = "Name",
  valueKey = "Id",
  iconKey = "",
  allOptionLabel = "All",
  allOptionIcon = "",
  noOptionsLabel = "No options available",
  searchable = false,
  searchPlaceholder = "Search...",
  onChange,
  rootClassName = "role-list",
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const dropdownRef = useRef(null);

  const filteredItems = useMemo(() => {
    if (!searchable) return items;

    return items.filter((item) =>
      String(item?.[labelKey] || "")
        .toLowerCase()
        .includes(searchText.toLowerCase())
    );
  }, [items, labelKey, searchText, searchable]);

  const shouldShowAllOption = useMemo(() => {
    if (!searchable) return true;

    const normalizedSearchText = searchText.trim().toLowerCase();
    if (!normalizedSearchText) return true;

    return String(allOptionLabel || "")
      .toLowerCase()
      .includes(normalizedSearchText);
  }, [allOptionLabel, searchText, searchable]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchText("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (item) => {
    onChange?.(item);
    setIsOpen(false);
    setSearchText("");
  };

  const renderItemLabel = (item, fallbackLabel) => {
    const iconSrc = iconKey ? item?.[iconKey] : "";
    const labelText = fallbackLabel ?? item?.[labelKey];

    return (
      <>
        {iconSrc ? (
          <img
            src={iconSrc}
            alt=""
            className="img-fluid me-3"
          />
        ) : null}
        <span>{labelText}</span>
      </>
    );
  };

  const dropdownItemTextStyle = {
    color: "#000000",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "24px",
  };

  return (
    <div
      ref={dropdownRef}
      className={`employee-list ${rootClassName}`.trim()}
    >
      <div className="dropdown form-input-container d-flex justify-content-center flex-column">
        <button
          id="role-dropdown-btn"
          className={`dropdown-toggle position-relative custom-dropdown-btn ${isOpen ? "show" : ""}`.trim()}
          type="button"
          onClick={() => {
            setIsOpen((prev) => !prev);
            if (isOpen) {
              setSearchText("");
            }
          }}
          aria-expanded={isOpen}
        >
          <p className="sub-dropdown-name">{label}</p>
          <span
            style={{ color: "#000000" }}
            className="d-inline-flex align-items-center"
          >
            {selectedItem
              ? <span>{selectedItem[labelKey]}</span>
              : <span>{placeholder}</span>}
          </span>
        </button>

        {isOpen && (
          <ul id="role-dropdown" className="dropdown-menu custom-dropdown show">
          {searchable && (
            <li className="px-3 py-2 no-option-marker">
              <input
                type="text"
                className="form-control"
                placeholder={searchPlaceholder}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                autoFocus
                // style={dropdownItemTextStyle}
              />
            </li>
          )}

            {shouldShowAllOption && (
              <li
                onClick={() => handleSelect(null)}
                className={!selectedItem ? "selected" : ""}
                role="button"
                tabIndex={0}
              >
                <a className="dropdown-item d-flex align-items-center">
                  {allOptionIcon ? (
                    <img
                      src={allOptionIcon}
                      alt=""
                      className="img-fluid me-3"
                      // style={{ width: "18px", height: "18px", objectFit: "contain" }}
                    />
                  ) : null}
                  {allOptionLabel}
                </a>
              </li>
            )}

            {filteredItems.length > 0 ? (
              filteredItems.map((item) => (
                <li
                  key={item[valueKey]}
                  onClick={() => handleSelect(item)}
                  className={
                    selectedItem?.[valueKey] === item[valueKey]
                      ? "selected"
                      : ""
                  }
                  role="button"
                  tabIndex={0}
                >
                  <a className="dropdown-item d-flex align-items-center">
                    {renderItemLabel(item)}
                  </a>
                </li>
              ))
            ) : !shouldShowAllOption ? (
              <div style={{ padding: "8px 12px", color: "#9ca3af" }}>
                {/* <span
                  className="dropdown-item text-muted d-flex align-items-center"
                  style={dropdownItemTextStyle}
                > */}
                  {noOptionsLabel}
                {/* </span> */}
              </div>
            ) : null}
          </ul>
        )}
      </div>
    </div>
  );
}

export default CustomDropdownWithLable;
